import { useNavigate } from 'react-router-dom'
import { useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'
import PageContainer from '@/common/components/PageContainer'
import Heading from '@/common/shared/heading'
import { Separator } from '@/common/ui/separator'
import { useMutationCreateSchedule } from '../../api/hooks'
import { transactionSettingsKeys } from '../../api/keys'
import { ScheduleForm } from '../../components'
import type { CreateTransactionScheduleDto } from '../../types'

const CreateDepositSchedulePage = () => {
	const navigate = useNavigate()
	const queryClient = useQueryClient()

	const createMutation = useMutationCreateSchedule({
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: transactionSettingsKeys.depositSchedules(),
			})
			queryClient.invalidateQueries({
				queryKey: transactionSettingsKeys.depositStatus(),
			})
			toast.success('สร้างตารางเวลาฝากเงินสำเร็จ')
			navigate('/operator/transaction-settings/deposit')
		},
		onError: () => {
			toast.error('เกิดข้อผิดพลาดในการสร้างตารางเวลา')
		},
	})

	const handleSubmit = (data: CreateTransactionScheduleDto) => {
		createMutation.mutate({ type: 'deposit', data })
	}

	return (
		<PageContainer>
			<div className="space-y-6 px-4 sm:px-0">
				<Heading
					title="เพิ่มตารางเวลาปิดฝากเงิน"
					description="กำหนดช่วงเวลาที่ระบบจะปิดรับฝากเงินอัตโนมัติทุกวัน"
				/>

				<Separator />

				<div className="max-w-2xl">
					<ScheduleForm
						onSubmit={handleSubmit}
						isLoading={createMutation.isPending}
						onCancel={() => navigate('/operator/transaction-settings/deposit')}
					/>
				</div>
			</div>
		</PageContainer>
	)
}

export default CreateDepositSchedulePage
